import { useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import { cioFacetsToUrlFilters } from '~/grid/utils/cioUtils';
import { useCioClient } from '~/shared/utils/useCioClient';

import getAllCioBrowseFacets from '../api/getAllCioBrowseFacets';
import { BROWSE_API_FACETS_STALE_TIME } from '../constants';

// We need to fetch all facets first to whitelist the selected facets from the url params
const useCioBrowseFacets = () => {
  const cioClient = useCioClient();

  const { asPath } = useRouter();
  const query = asPath.split('?')[1];

  const {
    data: allCioFacetsRaw,
    // isLoading: allCioFacetsIsLoading,
    // isFetching: allCioFacetsIsFetching,
    // error: allCioFacetsError,
  } = useQuery({
    queryKey: ['CioBrowse facets'],
    queryFn: () => {
      return getAllCioBrowseFacets({ cioClient });
    },
    enabled: Boolean(cioClient),
    staleTime: BROWSE_API_FACETS_STALE_TIME,
  });

  const allCioFacets = allCioFacetsRaw?.response?.facets;

  const memoizedAllCioFacetNames = useMemo(() => {
    return allCioFacets?.map((facet) => facet.name);
  }, [allCioFacets]);

  const memoizedSelectedUrlFilters = useMemo(() => {
    const selectedFacets = {};
    const urlParams = new URLSearchParams(query);

    if (memoizedAllCioFacetNames?.length > 0) {
      memoizedAllCioFacetNames.forEach((facetName) => {
        const mappedFacetName = cioFacetsToUrlFilters[facetName] || facetName;
        const facetValue = urlParams.get(mappedFacetName);
        if (facetValue) {
          selectedFacets[mappedFacetName] = facetValue.split(',');
        }
      });
    }
    return selectedFacets;
  }, [memoizedAllCioFacetNames, query]);

  return {
    allCioFacets,
    allCioFacetNames: memoizedAllCioFacetNames,
    selectedUrlFilters: memoizedSelectedUrlFilters,
  };
};

export default useCioBrowseFacets;
